interface Props {
  id?: string;
  no: string;
  title: string;
  desc: string;
  tone?: "accent" | "primary" | "secondary";
}

export default function SectionHead({ id, no, title, desc, tone = "accent" }: Props) {
  const colorMap: Record<string, string> = {
    accent: "text-accent-600 bg-accent-100",
    primary: "text-primary-600 bg-primary-100",
    secondary: "text-secondary-700 bg-secondary-100",
  };
  return (
    <div id={id} className="scroll-mt-24">
      <div className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ${colorMap[tone]}`}>
        <span className="font-poster">{no}</span>
        <span className="h-3 w-px bg-current opacity-40" />
        <span>词条</span>
      </div>
      <h2 className="eyebrow mt-4 text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
    </div>
  );
}